import * as React from 'react';
import Weighbridge from "./Weighbridge";

const Kiosk = () => {
    return (<Weighbridge />);
}

export default Kiosk;